export const productConsumptionsCategoriesOptions = [
    { key: 'otpisanaRoba', text: 'Otpisana roba', value: 'Otpisana roba' },
    { key: 'pokloni', text: 'Pokloni', value: 'Pokloni' },
    { key: 'edukacija', text: 'Edukacija', value: 'Edukacija' }
]
